export default __webpack_public_path__ + "static/media/gama.5b8b4a16.svg";